class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=cart-section`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-section',
        section: document.getElementById('cart-section').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'ajax-cart-icon',
        section: 'ajax-cart-icon',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'cart-section-total',
        section: document.getElementById('cart-section-total').dataset.id,
        selector: '.js-contents-subtotal',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('cart-section-total');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.cart-inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.item-title'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.ajax-loader').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item-error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('cart-section') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .ajax-loader`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .ajax-loader`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('cart-section') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .ajax-loader`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .ajax-loader`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('st-note')) {
  customElements.define(
    'st-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function checkCartDeliveryValidity() {
  const checkoutBtns = document.querySelectorAll(
    'button[name="checkout"], input[name="checkout"], .cart__checkout-button, #checkout'
  );

  let errorDiv = document.getElementById('Cart-Delivery-Error');
  if (!errorDiv) {
    const drawerItems = document.querySelector(
      '.drawer__items, .cart-drawer__items, .cart-items, form[action*="/cart"]'
    );

    if (drawerItems) {
      errorDiv = document.createElement('div');
      errorDiv.id = 'Cart-Delivery-Error';
      errorDiv.className = 'hide-element';
      errorDiv.style.cssText = 'color: #d9534f; background-color: #f2dede; border: 1px solid #ebccd1; padding: 10px 14px; margin: 10px 0 20px; border-radius: 4px; font-weight: 600; font-size: 13px; box-sizing: border-box; text-align: left;';
      drawerItems.insertBefore(errorDiv, drawerItems.firstChild);
    }
  }

  const defaultErrorMsg = window.expiredSlotErrorMessage || "The selected delivery slot has expired. Please select a new time slot.";

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasError = false;
      let errorMsg = '';
      const now = new Date();
      const currentHour = now.getHours();

      const globalAttr = cart.attributes || {};
      const dynamicSlots = window.globalMasterTimeSlots || {};

      cart.items.forEach(item => {
        const props = item.properties || {};
        
        const deliveryDateRaw = props['Delivery Date'] || props['Date'] || globalAttr['Delivery Date'] || globalAttr['Date'] || '';
        const deliveryTime = props['Delivery Time'] || props['Time Slot'] || globalAttr['Delivery Time'] || globalAttr['Time Slot'] || '';
        const deliveryType = props['Delivery Type'] || globalAttr['Delivery Type'] || '';

        if (!deliveryDateRaw) return;

        const isToday = deliveryDateRaw.toLowerCase().includes('today') || deliveryDateRaw.includes(getTodayDateString());

        if (isToday && deliveryTime) {
          let typeKey = 'standard';
          const typeLower = deliveryType.toLowerCase();
          if (typeLower.includes('same')) typeKey = 'same_day';
          else if (typeLower.includes('fixed')) typeKey = 'fixed_time';
          else if (typeLower.includes('midnight')) typeKey = 'midnight';

          const slots = dynamicSlots[typeKey] || [];
          
          const matchedSlot = slots.find(s => 
            cleanTimeString(s.text) === cleanTimeString(deliveryTime)
          );

          if (matchedSlot) {
            if (currentHour >= matchedSlot.endHour) {
              hasError = true;
              errorMsg = defaultErrorMsg;
            }
          } else {
            const extractedEndHour = extractEndHourFromText(deliveryTime);
            if (extractedEndHour !== null && currentHour >= extractedEndHour) {
              hasError = true;
              errorMsg = defaultErrorMsg;
            }
          }
        }
      });

      const cartItemElements = document.querySelectorAll('.cart-item[data-addon]');
      let addonOnlyCart = cartItemElements.length > 0;
      cartItemElements.forEach(el => {
        if (el.getAttribute('data-addon') !== 'true') {
          addonOnlyCart = false;
        }
      });

      if (hasError || addonOnlyCart) {
        if (errorDiv) {
          errorDiv.textContent = errorMsg;
          errorDiv.classList.remove('hide-element');
          errorDiv.style.display = hasError ? 'block' : 'none';
        }
        checkoutBtns.forEach(btn => {
          btn.disabled = true;
          btn.setAttribute('disabled', 'disabled');
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
        });
      } else {
        if (errorDiv) {
          errorDiv.classList.add('hide-element');
          errorDiv.style.display = 'none';
        }
        checkoutBtns.forEach(btn => {
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
        });
      }
    })
    .catch(err => console.error("Error checking cart delivery validity:", err));
}

function cleanTimeString(str) {
  if (!str) return '';
  return str.replace(/\s+/g, '').toLowerCase();
}

function getTodayDateString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function extractEndHourFromText(timeStr) {
  if (!timeStr) return null;
  
  const parts = timeStr.split(/to|-/i);
  if (parts.length < 2) return null;

  const endTimeStr = parts[1].trim().toLowerCase();
  
  let hour = parseInt(endTimeStr, 10);
  if (isNaN(hour)) return null;

  if (endTimeStr.includes('pm') && hour < 12) {
    hour += 12;
  } else if (!endTimeStr.includes('am') && hour >= 1 && hour <= 11) {
    hour += 12;
  }

  return hour;
}

document.addEventListener('DOMContentLoaded', checkCartDeliveryValidity);
window.addEventListener('pageshow', checkCartDeliveryValidity);
document.addEventListener('cart:updated', checkCartDeliveryValidity);